import React, { useEffect, useMemo, useState } from 'react'
import { Button } from './ui/button'
import { Link, useLocation } from 'react-router-dom'
import { sanity, urlFor } from '../lib/sanity'

const FOOTER_QUERY = `*[_type == "siteSettings"][0]{
  footerBanners[]{
    ...,
    alt,
    asset
  }
}`

const FALLBACK_BANNERS = [
  '/assets/images/banners/HC_banner_4.jpg',
  '/assets/images/banners/HC_banner_7.jpg',
  '/assets/images/banners/HC_banner_11.jpg',
]

function Footer() {
  const location = useLocation()
  const [footerBanners, setFooterBanners] = useState([])

  useEffect(() => {
    sanity
      .fetch(FOOTER_QUERY)
      .then((settings) => {
        if (settings?.footerBanners?.length) {
          setFooterBanners(settings.footerBanners)
        }
      })
      .catch((error) => {
        console.error('Footer banners konden niet geladen worden:', error)
      })
  }, [])

  const randomBanner = useMemo(() => {
    if (footerBanners.length) {
      return footerBanners[Math.floor(Math.random() * footerBanners.length)]
    }

    return FALLBACK_BANNERS[
      Math.floor(Math.random() * FALLBACK_BANNERS.length)
    ]
  }, [footerBanners, location.pathname])

  const bannerSrc =
    typeof randomBanner === 'string'
      ? randomBanner
      : urlFor(randomBanner).width(2400).height(1000).url()

  const bannerAlt =
    typeof randomBanner === 'string'
      ? 'Footer banner'
      : randomBanner?.alt || 'Footer banner'

  return (
    <footer className="m-2 rounded-3xl bg-white px-0 py-0 font-sans">
      <div className="relative mb-0 mx-0">
        <img
          src={bannerSrc}
          alt={bannerAlt}
          className="h-[32rem] w-full rounded-t-3xl object-cover"
        />
      </div>

      <div className="flex flex-col items-center justify-between gap-0 px-4 md:flex-row">
        <div className="flex flex-wrap justify-center gap-2 py-2">
          <a
            href="https://www.hc-slv.org"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            <Button
              variant="link"
              className="bg-transparent text-base text-[#5757fd] focus:outline-none focus:ring-0 focus-visible:outline-none"
            >
              Herdenkingscomité Slavernijverleden
            </Button>
          </a>

          <Link to="/deel-je-evenement">
            <Button
              variant="link"
              className="bg-transparent text-base text-[#5757fd] focus:outline-none focus:ring-0 focus-visible:outline-none"
            >
              Deel je evenement
            </Button>
          </Link>

          <Link to="/privacy-verklaring">
            <Button
              variant="link"
              className="bg-transparent text-base text-[#5757fd] focus:outline-none focus:ring-0 focus-visible:outline-none"
            >
              Privacyverklaring
            </Button>
          </Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer